import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PatientOverviewFields } from './patient-overview.model';
import { ErrorPanelService } from '../../../services/error-panel.service';

@Injectable({
  providedIn: 'root',
})
export class PatientOverviewService {
  private apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorPanelService: ErrorPanelService
  ) {}

  addHeader(): HttpHeaders {
    const token = sessionStorage.getItem('psicogeniusAccessToken');
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  startPatientPipeline(patientId: string): Observable<any> {
    const endpoint = this.apiUrl + '/patients/' + patientId + '/ai/pipeline';
    const headers = this.addHeader();

    return this.http.post(endpoint, {}, { headers });
  }

  getPatientOverviewFields(
    patientId: string
  ): Observable<PatientOverviewFields> {
    const endpoint =
      this.apiUrl + '/patients/' + patientId + '/ai/overview-fields';
    const headers = this.addHeader();

    return this.http.get<PatientOverviewFields>(endpoint, { headers });
  }

  stopOrDeletePatientPipeline(patientId: string): Observable<any> {
    const endpoint = `${this.apiUrl}/patients/${patientId}/ai/stop-or-delete-pipeline`;
    const headers = this.addHeader();

    return this.http.post(endpoint, {}, { headers });
  }
}
